<template>
  <div id="flowChartEdit"></div>
</template>
<script>
import '../../../public/static/mxgraph/styles/grapheditor.css';
import {
  findFlowChartById,
  editFlowChart,
  getFlowChartSidebar,
  getEditStyleOptions
} from '@/services/flowchart-service';
import $ from 'jquery';
export default {
  data() {
    return {
      timer: null,
      referTimer: null,
      user: this.$store.state.user.userInfo,
      flowId: this.$route.params.flowId,
      sideBarArr: []
    };
  },
  created() {
    window.sidebarAddPalette = this.sidebarAddPalette; // 添加左侧图形
    window.ebOkBtnGetPrettyXml = this.ebOkBtnGetPrettyXml; //点击获取代码ok按钮
    window.ebEditStyleOptions = this.ebEditStyleOptions; // 获取需要变换的图形
    this.getFlowChartSidebarService();
  },
  mounted() {
    let mxEditorClient = document.createElement('script');
    mxEditorClient.src = '/static/mxgraph/js/mxEditorClient.js';
    document.body.appendChild(mxEditorClient);
    this.timer = setInterval(() => {
      if (window.EditorUi) {
        clearInterval(this.timer);
        this.timer = null;
        this.init();
      }
    }, 1000);
  },
  methods: {
    init: function() {
      this.initEditorUi();
      this.initResource();
    },
    getFlowChartSidebarService: function() {
      this.sideBarArr = getFlowChartSidebar(this.user.roleid, this.user.userRoles);
    },
    initEditorUi: function() {
      var editorUiInit = EditorUi.prototype.init;
      EditorUi.prototype.init = function() {
        editorUiInit.apply(this, arguments);
        this.actions.get('export').setEnabled(false);

        // Updates action states which require a backend
        if (!Editor.useLocalStorage) {
          mxUtils.post(
            OPEN_URL,
            '',
            mxUtils.bind(this, function(req) {
              var enabled = req.getStatus() !== 404;
              this.actions.get('open').setEnabled(enabled || Graph.fileSupport);
              this.actions.get('import').setEnabled(enabled || Graph.fileSupport);
              this.actions.get('save').setEnabled(enabled);
              this.actions.get('saveAs').setEnabled(enabled);
              this.actions.get('export').setEnabled(enabled);
            })
          );
        }
      };
    },
    initResource: function() {
      mxResources.loadDefaultBundle = false;
      var bundle =
        mxResources.getDefaultBundle(RESOURCE_BASE, mxLanguage) ||
        mxResources.getSpecialBundle(RESOURCE_BASE, mxLanguage);
      mxUtils.getAll([bundle, STYLE_PATH + '/default.xml'], xhr => {
        mxResources.parse(xhr[0].getText());
        var themes = {};
        themes[Graph.prototype.defaultThemeName] = xhr[1].getDocumentElement();
        var editorUi = new EditorUi(new Editor(urlParams['chrome'] === '0', themes));
        editorUi.toggleFormatPanel(); // 默认隐藏右侧菜单
        this.initData(editorUi);
      });
    },
    async initData(editorUi) {
      this.$root.layout.isLoading = true;
      editorUi.editor.graph.model.beginUpdate();
      try {
        let { data } = await findFlowChartById(this.flowId);
        if (data.returnCode === '01') {
          if (data.flowChart.flowXml) {
            let flowXml = data.flowChart.flowXml;
            editorUi.editor.setGraphXml(mxUtils.parseXml(flowXml).documentElement);
          }
        } else if (data.returnCode === '03') {
          this.$message.error(data.message);
        } else {
          this.$message.error('获取流程图失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
      this.initStyle(editorUi);
      editorUi.editor.graph.model.endUpdate();
      let referCount = 0;
      this.referTimer = setInterval(() => {
        referCount++;
        if (referCount === 30) {
          clearInterval(this.referTimer);
          this.referTimer = null;
        }
        if ($('.geBackgroundPage').css('top') === '0px') {
          editorUi.refresh();
        } else {
          clearInterval(this.referTimer);
          this.referTimer = null;
        }
      }, 1000);
      this.$root.layout.isLoading = false;
    },
    initStyle: function(editorUi) {
      var _this = this;
      $('.geMenubarContainer').remove();
      $('.geSprite-editdiagram').removeClass('geSprite');
      $('.geSprite-editdiagram').addClass('icon iconfont icon-msnui-code');
      $('.geSprite-editdiagram')
        .css('border', 'none')
        .css('padding', '3px')
        .css('font-size', '16px');
      $('.geToolbarContainer').append(
        `<a href="javascript:void(0);" title="Fullscreen" class="geButton" style="position: absolute; display: inline-block; top: 5px; right: 73px; padding: 2px; font-size: 14px; width: 16px; height: 16px; background-position: 50% 50%; background-repeat: no-repeat; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABS0lEQVQ4T62TwVECQRBFf0MAYgRiBoSAGWgELrPcJQMxA7wz7RCBZqBGIBlICHBn61uf2qEGpLzgXHZrpvtN9+8/hjOXKb+u6zWAi5LVNM11Smmlvaqq+p1O58vMejmG5NrdLzOAOtAmgGf9u/u0BIYQJgB6Zqbv7rIYo5WAjQ5IJncfneqsrusE4B7ALvYAQPIJwMrMXk5BiuQFScU9loA1yZnKDiFUggC4izG+qZLxeDwk+Q5gEWOsQgjTA4BEyoK1og1UTUpJmkhEiaeYZW4t5+w0OGf9D+C4BfW83W6Xf7WQq96PUVOQiFltM7uZz+cfrdFuAbySHLl7kogAHg6MJICZ9ds579QutclgQSTo8RgpF7ZW/ZWcQYUXNI3BsROzlWetlWWs/WrLluUn+U2UAD2aqyJ+0zTNoHxM3W73uwSS/HT34dlj/AH7KNIRGLhsnwAAAABJRU5ErkJggg==');"></a>&nbsp;&nbsp;<a href="javascript:void(0);" title="Preview Panel" class="geButton" style="position: absolute; display: inline-block; top: 5px; right: 50px; padding: 2px; font-size: 14px; width: 16px; height: 16px; background-position: 50% 50%; background-repeat: no-repeat; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAo0lEQVQ4T+2SsQ0CMQxF/aX0MAJlpLhgBBiBDW4jGIER2AAxQxwp5Y3AAJGMfLqLRAEEhZJfJbL/K/w/qFPo9NMECCFcAKy+hN1F5DABmFmJaN8KUNUtgKOIoALs0wpg5h0RXf+AX98AgF22SRYjEZ1qCnOR1k3ueUlVx5TS8JS95QvASvVWMcbbslAB3vuNc+78yWzzUsqQcx7t3dy+V+BuwANX7VoRrx4R3gAAAABJRU5ErkJggg==');"></a>&nbsp;&nbsp;<a href="javascript:void(0);" title="Format Panel (Ctrl+Shift+P)" class="geButton" style="position: absolute; display: inline-block; top: 5px; right: 6px; padding: 2px; font-size: 14px; width: 16px; height: 16px; background-position: 50% 50%; background-repeat: no-repeat; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAfklEQVQ4T+3TwQ2CQBCF4Y8O7EBKsAOxA0ugBEqwJSsQKoBS6AAzYTWaeGDOMpedw3t/Npt/K+vUOJY9cwxVSfc4Z5ole/kEBOSWgCxIAU4YcccVaUCDBwbEvgP+8w0OCJlmTL88CDFC560T2r9V7oqeW8uRi5u0r8+UKX5ln0MMP2FDItXQAAAAAElFTkSuQmCC');"></a>&nbsp;&nbsp;<a href="javascript:void(0);" title="Property Panel" class="geButton" style="position: absolute; display: inline-block; top: 5px; right: 28px; padding: 2px; font-size: 14px; width: 16px; height: 16px; background-position: 50% 50%; background-repeat: no-repeat; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAgElEQVQ4T2NkgAAFBgYGeSibFOogI1T1AQYGBntSdELVOiIbADKkgQRD/jMwMGAYsIGBgeE8AwPDRgYGhgAChmE1AOSK/QwMDAcZGBgcRg0YsWEwgYGBwYCBgeEDAwPDBVLTAShlgRISsQCU7OFJuYCIpItuMMiVCbDMRKytGOoAcyo/YeP/2LEAAAAASUVORK5CYII=');"></a>`
      );
      $("a[title='Fullscreen']").click(function(event) {
        toggleFullScreen();
      });

      $("a[title='Preview Panel']").click(function(event) {
        let xml = mxUtils.getPrettyXml(editorUi.editor.getGraphXml());
        sessionStorage.setItem('ebFlowChartXml', xml);
        window.open('/flowchart/view/' + _this.flowId);
      });

      $("a[title='Format Panel (Ctrl+Shift+P)']").click(function(event) {
        editorUi.toggleFormatPanel();
      });

      $("a[title='Property Panel']").click(function(event) {
        if (editorUi.hsplitPosition === 0) {
          editorUi.hsplitPosition = 208;
        } else {
          editorUi.hsplitPosition = 0;
        }
        editorUi.refresh();
      });
      var toggleFullScreen = function() {
        // 全屏
        if (
          !document.fullscreenElement && // alternative standard method
          !document.mozFullScreenElement &&
          !document.webkitFullscreenElement &&
          !document.msFullscreenElement
        ) {
          // current working methods
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
          } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          }
        }
      };
    },
    // 添加左侧图形
    sidebarAddPalette: function(sidebar, expand) {
      this.sideBarArr.forEach((element, index) => {
        let fns = [];
        element.data.forEach((ele, ind) => {
          fns.push(
            sidebar.addEntry(element.id, function() {
              return sidebar.createVertexTemplateFromData(
                sidebar.graph.compress(ele.xml),
                ele.width,
                ele.height,
                ele.value
              );
            })
          );
        });
        sidebar.addPaletteFunctions(element.id, element.title, expand != null ? expand : true, fns);
      });
    },
    // 点击获取xml确定按钮
    async ebOkBtnGetPrettyXml(xml) {
      let params = {
        updateId: this.user.userid,
        flowId: this.flowId,
        flowXml: xml
      };
      try {
        let { data } = await editFlowChart(params);
        if (data.returnCode === '01') {
          this.$message.success('保存成功');
        } else {
          this.$message.error('保存失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    ebEditStyleOptions: function() {
      return getEditStyleOptions();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    clearInterval(this.referTimer);
    this.referTimer = null;
  }
};
</script>
